import Image from '@global/Image'
import { getCTALink, stripTags } from '@lib/helpers'
import { Link } from '@routes'
import { Col, Container, Row } from '@styles/global.styled'
import htmr from 'htmr'
import * as S from './TwinEqualCTA.styled'

export const TwinCard = ({ title, description, image, url }) => {
  return (
    <S.Card withLink={!!url}>
      <S.CardImage>
        <Image src={image} alt={title} />
      </S.CardImage>
      <S.CardBody>
        <S.CardTitle>{title}</S.CardTitle>
        <S.CardDescription>{description}</S.CardDescription>
      </S.CardBody>
      <Link route={url} passHref />
    </S.Card>
  )
}

const TwinEqualCTA = ({ items, title, titleStyle }) => {
  return (
    <S.TwinEqualCTA>
      <Container>
        {title && <S.Title titleStyle={titleStyle}>{title}</S.Title>}
        {items?.length > 0 && (
          <Row gutter={15}>
            {items.map((it, index) => (
              <Col md={6} key={`panel-${index}`}>
                <TwinCard {...it} />
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </S.TwinEqualCTA>
  )
}

TwinEqualCTA.ApiBlockToProps = (data) => {
  const { title } = data.value
  const itemsData = data.value.panels || data.value.lifestyles
  const items = itemsData?.map((it) => ({
    title: it.heading || it.title,
    image: it.image || it.hero_image_thumb.url,
    description: it.hover_text || htmr(stripTags(it.content)),
    url: getCTALink(it)?.href || it.get_url,
  }))

  return {
    title,
    items,
  }
}

export default TwinEqualCTA
